import { Component, OnInit, Input } from '@angular/core';

import { Material } from "../../material/shared/material.model";
import { MaterialEspecificacao } from "../shared/material-especificacao.model";
import { MaterialEspecificacaoService } from "../shared/material-especificacao.service";
import { UtilService } from "../../../../shared/services/util.service";
import { MaterialCodigoBarra } from "../../material-codigo-barra/shared/material-codigo-barra.model";
import { materialEspecificacaoTitle } from "../../material/shared/data.service";
import { MaterialService } from "../../material/shared/material.service";

declare var swal: any;

@Component({
  selector: 'material-especificacao-list',
  template: require('./material-especificacao-list.component.html')
})

export class MaterialEspecificacaoListComponent implements OnInit {
  @Input() materialObject: Material = new Material();

  materialEspecificacaoTitle: any = materialEspecificacaoTitle;
  list: Array<MaterialEspecificacao> = [];
  showDisabled: boolean = false;
  showLoad: boolean = true;

  constructor(
    private _service: MaterialEspecificacaoService,
    private _materialService: MaterialService,
    private _utilService: UtilService
  ){}

  ngOnInit() {
    var onDone = (function(Response: any) {
      if (!Response.error) {
        this.list = Response;
      } else {
        this._utilService.swalMessageWarningCustom(Response.error);
      }
      this.showLoad = false;
    }.bind(this));

    this._service.onGetbyMaterial(this.materialObject.id, onDone);
  }

  onclickGoToAdd() {
    this._materialService.clearStorage();

    var object: any = new MaterialCodigoBarra();
    object.material = this.materialObject;

    this._service.setStorage(object);
    this._service.goToAdd();
  }

  onclickGoToEdit(item: any) {
    this._materialService.clearStorage();

    item.material = this.materialObject;

    this._service.setStorage(item);
    this._service.goToEdit(item.id);
  }

  onclickDelete(item: any) {
    swal({
        title: "Você deseja realmente excluir este item?",
        text: "O item será desativado.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, Excluir",
        cancelButtonText: "Cancelar",
        closeOnConfirm: false
      },
      function() {
        this.onDelete(item);
      }.bind(this)
    );
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error) {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._service.onDelete(item.id, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-especificacao/material-especificacao-list/material-especificacao-list.component.ts
 **/